import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import AssistanceActions, { AssistanceRedux, AssistanceTypes } from '../Redux/AssistanceRedux'
import { notificationFail } from '../Redux/NotificationActions'

const assistanceCrudObservable = createCRUDObservable({
  mainRedux: AssistanceRedux,
  reduxPath: 'assistance',
})

const assistanceByHourExcelEpic = (action$, store, { Api }) =>
  action$.ofType(AssistanceTypes.AssistanceByHourExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.assistance.getAssistanceByHourExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            AssistanceActions.AssistanceByHourExcelSuccess(),
          ]
        })
    ))

const assistanceExcelEpic = (action$, store, { Api }) =>
  action$.ofType(AssistanceTypes.AssistanceExcelRequest)
  .mergeMap(({ start_date,end_date,path }) => (
    Observable
        .fromPromise(Api.assistance.getAssistanceExcel(start_date,end_date,path)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            AssistanceActions.AssistanceExcelSuccess(),
          ]
        })
    ))
const assistanceCenterExcelEpic = (action$, store, { Api }) =>
  action$.ofType(AssistanceTypes.AssistanceCenterExcelRequest)
  .mergeMap(({ start_date,end_date,centerId,path }) => (
    Observable
        .fromPromise(Api.assistance.getAssistanceCenterExcel(start_date,end_date,centerId,path)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            AssistanceActions.AssistanceCenterExcelSuccess(),
          ]
        })
    ))

export const assistanceObservers = Object.assign({}, assistanceCrudObservable.observers, {})

export const assistanceEpic = combineEpics(
  assistanceCrudObservable.epic,
  assistanceByHourExcelEpic,
  assistanceExcelEpic,
  assistanceCenterExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/AssistanceObservable.js